import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';

var returnSortedNavigation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(props) {
    var GetSortOrder, dynamicSort, procesItem, processArray, websiteNavItems, _websiteNavItems;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!props.websiteNavLoading) {
              _context3.next = 18;
              break;
            }

            GetSortOrder = function GetSortOrder(prop) {
              return function (a, b) {
                if (a[prop] > b[prop]) {
                  return 1;
                } else if (a[prop] < b[prop]) {
                  return -1;
                }

                return 0;
              };
            };

            dynamicSort = function dynamicSort(property) {
              var sortOrder = 1;

              if (property[0] === '-') {
                sortOrder = -1;
                property = property.substr(1);
              }

              return function (a, b) {
                /* next line works with strings and numbers,
                 * and you may want to customize it to your needs
                 */
                var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                return result * sortOrder;
              };
            };

            procesItem = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, newArrayOrder) {
                var newChildrenOrder;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!item.children) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 3;
                        return item.children.sort(dynamicSort('order'));

                      case 3:
                        newChildrenOrder = _context.sent;
                        item.children = newChildrenOrder;
                        newArrayOrder.push(item);
                        _context.next = 9;
                        break;

                      case 8:
                        newArrayOrder.push(item);

                      case 9:
                        return _context.abrupt("return", item);

                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function procesItem(_x2, _x3) {
                return _ref2.apply(this, arguments);
              };
            }();

            processArray = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(array) {
                var newArrayOrder, _iterator, _step, item;

                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        newArrayOrder = [];
                        _iterator = _createForOfIteratorHelperLoose(array);

                      case 2:
                        if ((_step = _iterator()).done) {
                          _context2.next = 8;
                          break;
                        }

                        item = _step.value;
                        _context2.next = 6;
                        return procesItem(item, newArrayOrder);

                      case 6:
                        _context2.next = 2;
                        break;

                      case 8:
                        _context2.next = 10;
                        return newArrayOrder.sort(dynamicSort('order'));

                      case 10:
                        newArrayOrder = _context2.sent;
                        return _context2.abrupt("return", newArrayOrder);

                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function processArray(_x4) {
                return _ref3.apply(this, arguments);
              };
            }();

            if (!props.fromGQL) {
              _context3.next = 13;
              break;
            }

            _context3.next = 8;
            return processArray(props.websiteNavJSON.allAccroPress.nodes[0].menu);

          case 8:
            websiteNavItems = _context3.sent;

            if (websiteNavItems) {
              props.setWebsiteNavData(websiteNavItems);
            } else {
              props.setWebsiteNavData(props.websiteNavJSON.allAccroPress.nodes[0].menu);
            }

            props.setWebsiteNavLoading(false);
            _context3.next = 18;
            break;

          case 13:
            _context3.next = 15;
            return processArray(props.websiteNavJSON.menu);

          case 15:
            _websiteNavItems = _context3.sent;

            if (_websiteNavItems) {
              props.setWebsiteNavData(_websiteNavItems);
            } else {
              props.setWebsiteNavData(props.websiteNavJSON.menu);
            }

            props.setWebsiteNavLoading(false);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function returnSortedNavigation(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default returnSortedNavigation;